<template>
  <f7-page
    :page-content="true"
  >
    <f7-navbar title="No se encontró la página" back-link="Back"></f7-navbar>
    <img class="wd-100 m-t-30" src="assets/img/otros/not-found.jpg" alt="" srcset="">
    <f7-block class="text-center m-t-10">
      <img src="assets/img/otros/logo_bg_2.jpg" alt="" width="100">
      <p class="bold fs-30 m-t-10 m-b-10">Lo sentimos</p>
      <div class="alert alert-secondary bold fs-16 m-t-20">La página a la que intentas acceder no existe o fue eliminada.</div>
    </f7-block>
  </f7-page>
</template>
<script>
export default {}
</script>
